import React, { createContext, useContext, ReactNode } from 'react';
import useViewportHeight from '../hooks/useViewportHeight';

interface ViewportHeightContextType {
  vh: number;
  dvh: number;
  lvh: number;
  svh: number;
}

const ViewportHeightContext = createContext<ViewportHeightContextType | undefined>(undefined);

interface ViewportHeightProviderProps {
  children: ReactNode;
}

export const ViewportHeightProvider: React.FC<ViewportHeightProviderProps> = ({ children }) => {
  const viewportHeight = useViewportHeight();

  return (
    <ViewportHeightContext.Provider value={viewportHeight}>
      {children}
    </ViewportHeightContext.Provider>
  );
};

export const useViewportHeightContext = (): ViewportHeightContextType => {
  const context = useContext(ViewportHeightContext);
  if (context === undefined) {
    throw new Error('useViewportHeightContext must be used within a ViewportHeightProvider');
  }
  return context;
};
